(() => {
  const INFO_URL = 'https://procykling.dk/pages/lagerstatus-og-fjernlager';
  const LOCAL_DELIVERY_TEXT = 'Hurtig levering';
  const REMOTE_DELIVERY_TEXT = '2-3 dages leveringstid';
  const INVENTORY_TIMEOUT_MS = 8000;

  const formatDateDMY = (value) => {
    if (!value) return null;

    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);

    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
  };

  const formatQty = (qty) => {
    const n = Number(qty || 0);
    if (!Number.isFinite(n) || n <= 0) return null;

    return n > 10 ? '10+' : String(n);
  };

  const placeholders = document.querySelectorAll('[data-csn-stock-status]');
  if (!placeholders.length) return;

  const styles = `
    /* Dots */
    .csn-stock-dot { width:10px; height:10px; border-radius:50%; display:inline-block; flex:0 0 auto; }
    .csn-dot-green { background:#16a34a; }
    .csn-dot-yellow { background:#eab308; }
    .csn-dot-red { background:#dc2626; }

    /* ATC */
    .csn-atc-disabled { opacity:0.6 !important; cursor:not-allowed !important; }

    /* Card/table look (match "specifications"-foelelse) */
    .csn-stock-card {
      border: 1px solid rgba(0,0,0,0.12);
      border-radius: 12px;
      padding: 14px;
      margin: 12px 0;
      background: rgba(0,0,0,0.02);
    }
    .csn-stock-card h3 {
      margin: 0 0 10px 0;
      font-size: 1.05rem;
      line-height: 1.2;
    }
    .csn-stock-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 0.95rem;
    }
    .csn-stock-table th {
      text-align: left;
      padding: 8px 12px 8px 0;
      vertical-align: top;
      opacity: 0.8;
      width: 38%;
      white-space: nowrap;
    }
    .csn-stock-table td {
      padding: 8px 0;
      vertical-align: top;
    }
    .csn-stock-table tr + tr th,
    .csn-stock-table tr + tr td {
      border-top: 1px solid rgba(0,0,0,0.08);
    }

    .csn-stock-statusline {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
    }

    .csn-stock-badge {
      display: inline-flex;
      align-items: center;
      padding: 2px 10px;
      border-radius: 999px;
      font-size: 0.88em;
      border: 1px solid rgba(0,0,0,0.12);
      background: rgba(0,0,0,0.04);
      line-height: 1.4;
    }
    .csn-badge-green { background: rgba(22,163,74,0.10); border-color: rgba(22,163,74,0.25); }
    .csn-badge-yellow { background: rgba(234,179,8,0.12); border-color: rgba(234,179,8,0.30); }
    .csn-badge-red { background: rgba(220,38,38,0.10); border-color: rgba(220,38,38,0.25); }

    .csn-stock-footnote {
      margin-top: 10px;
      font-size: 0.92em;
      opacity: 0.85;
    }
    .csn-stock-footnote a { text-decoration: underline; }
    .csn-stock-footnote a:hover { text-decoration: none; }
  `;
  const styleEl = document.createElement('style');
  styleEl.textContent = styles;
  document.head.appendChild(styleEl);

  const findAddToCartButtons = () =>
    Array.from(document.querySelectorAll('form[data-type="add-to-cart-form"] [type="submit"], form[action*="/cart/add"] [type="submit"], button[name="add"]'));

  const getButtonLabelEl = (btn) => {
    if (!btn || btn.tagName === 'INPUT') return null;

    return btn.querySelector('[data-csn-atc-label], .product-form__submit span, span');
  };

  const getButtonText = (btn) => {
    if (!btn) return '';
    if ('value' in btn && btn.tagName === 'INPUT') return btn.value || '';

    const label = getButtonLabelEl(btn);
    return (label ? label.textContent : btn.textContent || '').trim();
  };

  const setButtonText = (btn, text) => {
    if ('value' in btn && btn.tagName === 'INPUT') {
      btn.value = text;
      return;
    }

    const label = getButtonLabelEl(btn);
    if (label) {
      label.textContent = text;
      return;
    }

    if (!btn.children.length) {
      btn.textContent = text;
    }
  };

  const setAtcEnabled = (enable, msg) => {
    findAddToCartButtons().forEach((btn) => {
      if (!enable) {
        if (btn.dataset.csnStockLocked !== 'true') {
          btn.dataset.csnWasDisabled = btn.disabled ? 'true' : 'false';
          btn.dataset.originalText = btn.dataset.originalText || getButtonText(btn);
        }

        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.dataset.csnStockLocked = 'true';
        btn.classList.add('csn-atc-disabled');

        if (msg) {
          setButtonText(btn, msg);
        }

        return;
      }

      if (btn.dataset.csnStockLocked === 'true') {
        if (btn.dataset.csnWasDisabled !== 'true') {
          btn.disabled = false;
        }

        btn.setAttribute('aria-disabled', btn.disabled ? 'true' : 'false');
        btn.classList.remove('csn-atc-disabled');

        if (btn.dataset.originalText) {
          setButtonText(btn, btn.dataset.originalText);
        }

        delete btn.dataset.csnStockLocked;
        delete btn.dataset.csnWasDisabled;
      } else {
        btn.classList.remove('csn-atc-disabled');
      }

      if (enable && btn.dataset.originalText) {
        setButtonText(btn, btn.dataset.originalText);
      }
    });
  };

  const buildUrl = (variantId, productId, baseOverride) => {
    let url = `${baseOverride || window.CSN_INVENTORY_BASE_URL || '/apps/csn-inventory'}?variantId=${encodeURIComponent(variantId)}`;
    if (productId) {
      url += `&productId=${encodeURIComponent(productId)}`;
    }

    return url;
  };

  const fetchInventory = async (url) => {
    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    let timeoutId;

    const timeout = new Promise((_, reject) => {
      timeoutId = window.setTimeout(() => {
        if (controller) {
          controller.abort();
        }

        reject(new Error(`Inventory lookup timed out after ${INVENTORY_TIMEOUT_MS}ms`));
      }, INVENTORY_TIMEOUT_MS);
    });

    try {
      const request = fetch(url, {
        credentials: 'omit',
        ...(controller ? { signal: controller.signal } : {})
      });

      return await Promise.race([request, timeout]);
    } finally {
      window.clearTimeout(timeoutId);
    }
  };

  const infoLinkHtml = () =>
    `<a href="${INFO_URL}" target="_blank" rel="noopener noreferrer">Om lagerstatus og fjernlager</a>`;

  const statusLineHtml = (color, label) =>
    `<span class="csn-stock-statusline"><span class="csn-stock-dot csn-dot-${color}" aria-hidden="true"></span><span>${label}</span></span>`;

  const badgeHtml = (color, htmlText) =>
    `<span class="csn-stock-badge csn-badge-${color}">${htmlText}</span>`;

  const render = (el, data) => {
    if (!data || data.error) {
      el.innerHTML = `
        <div class="csn-stock-card">
          <h3>Lagerstatus</h3>
          <table class="csn-stock-table">
            <tbody>
              <tr><th>Status</th><td>${statusLineHtml('red', 'Ingen lagerinformation')}</td></tr>
              <tr><th>Antal</th><td>&mdash;</td></tr>
              <tr><th>Levering</th><td>&mdash;</td></tr>
            </tbody>
          </table>
        </div>`;
      setAtcEnabled(false, 'Ikke på lager');
      return;
    }

    const tracksInventory = data.tracksInventory !== false;
    const local = Math.max(Number(data.localQuantity || 0), 0);
    const remote = Math.max(Number(data.remoteQuantity || 0), 0);
    const restock = formatDateDMY(data.restockDate);
    const localQty = formatQty(local);
    const remoteQty = formatQty(remote);

    let color = 'red';
    let statusLabel = 'Ikke på lager';
    let qtyCell = '&mdash;';
    let deliveryCell = '&mdash;';
    let canBuy = false;
    let addInfoLink = false;

    if (!tracksInventory) {
      color = 'green';
      statusLabel = 'På lager';
      canBuy = true;
    } else if (local > 0) {
      color = 'green';
      statusLabel = 'På lager (lokalt)';
      qtyCell = badgeHtml('green', `<strong>${localQty}</strong> stk`);
      deliveryCell = LOCAL_DELIVERY_TEXT;
      canBuy = true;
    } else if (remote > 0) {
      color = 'yellow';
      statusLabel = 'Fjernlager';
      qtyCell = badgeHtml('yellow', `${remoteQty || '&mdash;'} stk`);
      deliveryCell = REMOTE_DELIVERY_TEXT;
      canBuy = true;
      addInfoLink = true;
    } else if (restock) {
      color = 'red';
      statusLabel = 'Midlertidigt udsolgt';
      qtyCell = badgeHtml('red', '0 stk');
      deliveryCell = `Forventet på lager: <strong>${restock}</strong>`;
      addInfoLink = true;
    } else {
      qtyCell = badgeHtml('red', '0 stk');
      addInfoLink = true;
    }

    el.innerHTML = `
      <div class="csn-stock-card">
        <h3>Lagerstatus</h3>
        <table class="csn-stock-table">
          <tbody>
            <tr>
              <th>Status</th>
              <td>${statusLineHtml(color, statusLabel)}</td>
            </tr>
            <tr>
              <th>Antal</th>
              <td>${qtyCell}</td>
            </tr>
            <tr>
              <th>Levering</th>
              <td>${deliveryCell}</td>
            </tr>
          </tbody>
        </table>
        ${addInfoLink ? `<div class="csn-stock-footnote">${infoLinkHtml()}</div>` : ''}
      </div>
    `;
    setAtcEnabled(canBuy, 'Ikke på lager');
  };

  const loadingHtml = `
    <div class="csn-stock-card">
      <h3>Lagerstatus</h3>
      <table class="csn-stock-table">
        <tbody>
          <tr><th>Status</th><td>${statusLineHtml('yellow', 'Opdaterer...')}</td></tr>
          <tr><th>Antal</th><td>&mdash;</td></tr>
          <tr><th>Levering</th><td>&mdash;</td></tr>
        </tbody>
      </table>
    </div>`;

  const load = async (el) => {
    const variantId = el.dataset.variantId;
    const productId = el.dataset.productId;
    const baseOverride = el.dataset.proxyBase;

    setAtcEnabled(false, 'Opdaterer...');

    if (!variantId) {
      render(el, { error: true });
      return;
    }

    el.innerHTML = loadingHtml;

    try {
      const response = await fetchInventory(buildUrl(variantId, productId, baseOverride));
      if (!response.ok) {
        throw new Error(`Inventory lookup failed with status ${response.status}`);
      }

      const data = await response.json();
      render(el, data);
    } catch (err) {
      console.warn('CSN stock status lookup failed', err);
      render(el, { error: true });
    }
  };

  setAtcEnabled(false, 'Opdaterer...');
  placeholders.forEach(load);
})();
